import authInstance from '../Interceptor/interceptor';

export const addSpecialistEffect = (formData) => {
  return authInstance.post('/specialization/insert', formData);
};

export const deleteSpecialistEffect = (id) => {
  return authInstance.delete(`/specialization/delete/${id}`);
};

export const editSpecialistEffect = (ids) => {
  const { Name, id, status } = ids;
  const formData = { Name, status };
  return authInstance.put(`/specialization/update/${id}`, formData);
};

export const viewSpecialistEffect = () => {
  return authInstance.get('/Specialist/list');
};
export const listSpecialistEffect = (pageNo) => {
  return authInstance.get(
    `/specialization/getlist?pageNo=1&pagesize=10&pagination_required=false`
  );
};
